/**
 * Shop by Pro — pros directory (custom Padel USA).
 * <pros-directory> on /pages/pros: men/women toggle + FIP-rank sort (cards carry data-rank).
 * Progressive enhancement: without JS all cards render (men first), unsorted.
 * Docs: custom-code-padelusa/features/shop-by-pro.md
 */
(() => {
  if (customElements.get('pros-directory')) return;

  customElements.define(
    'pros-directory',
    class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-pros-grid]');
        this.tabs = [...this.querySelectorAll('[data-pros-tab]')];
        if (!this.grid) return;

        this.#sort();
        this.tabs.forEach((tab) =>
          tab.addEventListener('click', () => this.#show(tab.dataset.prosTab))
        );
        const active = this.tabs.find((tab) => tab.getAttribute('aria-pressed') === 'true');
        this.#show(active ? active.dataset.prosTab : 'men');
      }

      #sort() {
        [...this.grid.children]
          .sort((a, b) => (Number(a.dataset.rank) || 999) - (Number(b.dataset.rank) || 999))
          .forEach((card) => this.grid.appendChild(card));
      }

      #show(group) {
        this.tabs.forEach((tab) =>
          tab.setAttribute('aria-pressed', tab.dataset.prosTab === group ? 'true' : 'false')
        );
        [...this.grid.children].forEach((card) => {
          card.hidden = card.dataset.group !== group;
        });
      }
    }
  );
})();
